import { render } from "./zj-container.vue?vue&type=template&id=344fda8e"
const script = {}

import "./zj-container.vue?vue&type=style&index=0&id=344fda8e&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__